import { PayloadAction } from '@reduxjs/toolkit';

import { DemoAppState, DemoProduct } from '../types';

const setDemoProductsReducer = (state: DemoAppState, action: PayloadAction<DemoProduct[]>) => {
  state.products = action.payload;
};

export default setDemoProductsReducer;
